export const rendererPrice = (price) => {
  const strPrice = String(price);
  return strPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}
